import {
  type ControlConfiguration,
  DefaultBrandKitValue,
} from '@src/components/sidepanel/CompositionSettings/types';
import {
  Button,
  CaretDownIcon,
  CaretUpIcon,
  Dropdown,
  DropdownMenu,
  DropdownOption,
  TextInput,
} from 'datocms-react-ui';

type ColorControlSelectorProps = {
  control: ControlConfiguration & { enabled?: boolean };
  onUpdateCustomValue: (
    newValue:
      | {
          value?: string | number;
          brandKit?: DefaultBrandKitValue;
        }
      | undefined,
  ) => void;
  isCustomValue: boolean;
  customValue: string | undefined;
  setCustomValue: (value: string | undefined) => void;
  handleUpdateCustomValue: (
    newValue:
      | {
          value?: string | number;
        }
      | undefined,
  ) => void;
};

const getBrandKitValue = (control: ControlConfiguration) => {
  if (control.default?.brandKit === DefaultBrandKitValue.PRIMARY_COLOR)
    return 'Primary Color';
  if (control.default?.brandKit === DefaultBrandKitValue.SECONDARY_COLOR)
    return 'Secondary Color';
  if (
    control.default?.brandKit === undefined &&
    control.default?.value === undefined
  )
    return 'None';
  if (
    control.default?.brandKit === undefined &&
    control.default?.value !== undefined
  )
    return control.default?.value as string;
  return 'None';
};

export function ColorControlSelector({
  control,
  onUpdateCustomValue,
  isCustomValue,
  customValue,
  setCustomValue,
  handleUpdateCustomValue,
}: ColorControlSelectorProps) {
  return (
    <Dropdown
      renderTrigger={({ open, onClick }) => (
        <Button
          buttonSize="xxs"
          type="button"
          onClick={onClick}
          rightIcon={open ? <CaretUpIcon /> : <CaretDownIcon />}
        >
          <span>{getBrandKitValue(control)}</span>
        </Button>
      )}
    >
      <DropdownMenu>
        <DropdownOption
          active={getBrandKitValue(control) === 'Primary Color'}
          onClick={() => {
            onUpdateCustomValue({
              brandKit: DefaultBrandKitValue.PRIMARY_COLOR,
            });
          }}
        >
          Primary Color
        </DropdownOption>
        <DropdownOption
          active={getBrandKitValue(control) === 'Secondary Color'}
          onClick={() => {
            onUpdateCustomValue({
              brandKit: DefaultBrandKitValue.SECONDARY_COLOR,
            });
          }}
        >
          Secondary Color{' '}
        </DropdownOption>
        <DropdownOption
          active={getBrandKitValue(control) === 'None'}
          onClick={() => {
            onUpdateCustomValue(undefined);
          }}
        >
          None
        </DropdownOption>
        <DropdownOption
          active={isCustomValue}
          onClick={() => {
            onUpdateCustomValue({ value: '' });
            if (!customValue) {
              setCustomValue('');
            }
          }}
          closeMenuOnClick={false}
        >
          {isCustomValue ? (
            <TextInput
              type="text"
              value={customValue}
              onChange={value => {
                handleUpdateCustomValue({ value: value });
              }}
              placeholder="Hex or RGBA value"
            />
          ) : (
            'Custom Value'
          )}
        </DropdownOption>
      </DropdownMenu>
    </Dropdown>
  );
}
